// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoScreenDesktop_root__3Jtzq","body":"InfoScreenDesktop_body__1LymR","item":"InfoScreenDesktop_item__2Wq6o"};